<template>
  <div class="login-container">

    <div class="top">
      <img src="../img/logo.png">
      <p>万物追溯管理后台</p>
    </div>

    <div class="main">
      <el-form :model="loginForm" :rules="rules" ref="loginFormName" class="demo-ruleForm">
        <el-form-item label="" prop="username">
          <el-input v-model="loginForm.username" placeholder="用户名" clearable></el-input>
        </el-form-item>
        <el-form-item label="" prop="password">
          <el-input type="password" v-model="loginForm.password" placeholder="密码" clearable show-password></el-input>
        </el-form-item>
        <el-form-item>
          <el-button plain @click="submitForm('loginFormName')">登录</el-button>
        </el-form-item>
      </el-form>
    </div>

  </div>
</template>

<script>
export default {
  name: "login",
  data() {
    return {
      loginForm: {
        username: '',
        password: '',
      },
      rules: {
        username: [
          {required: true, message: '请输入用户名', trigger: 'blur'}
        ],
        password: [
          {required: true, message: '请输入用户名', trigger: 'blur'}
        ]
      }
    }
  },
  methods: {
    submitForm(loginFormName) {
      this.$refs[loginFormName].validate((valid) => {
        if (valid) {
          this.axios.post('administrator/login', {
            username: this.loginForm.username,
            password: this.loginForm.password
          }).then(success => {
            console.log(success)

            if (success.data.errno === 0) {
              sessionStorage.setItem('info', JSON.stringify(success.data.data))
              this.$router.push({path: '/home'})
            } else {
              alert('用户名或密码错误，请重新登录')
            }
          })
        } else {
          alert('请将信息填写完整')
        }
      });
    }
  }
}
</script>

<style lang="scss">

.login-container {
  width: 1200px;
  text-align: center;
  margin: 0 auto;

  .top {
    height: 50px;
    margin: 0 auto;
    display: inline-block;
    margin-top: 100px;

    img {
      width: 80px;
      height: 80px;
      float: left;
    }

    p {
      font-size: 40px;
      font-weight: bolder;
      line-height: 80px;
      float: left;
      margin-left: 30px;
    }
  }

  .main {
    width: 480px;
    margin: 0 auto;
    margin-top: 160px;


    .el-form-item {
      margin-top: 50px;
    }

    .el-form-item:last-child {
      margin-top: 100px;
    }

    .el-button {
      width: 150px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/page/login.vue